module.exports = __webpack_public_path__ + "static/img/sahua.bafc6eb1.png";